import { Pipe, PipeTransform } from '@angular/core';
import { DiscountSummary } from '../models/discount.model';
import { OrderStatus, OrderType, StatusReason } from '../models/constants';

@Pipe({
  name: 'termLength'
})
export class TermLengthPipe implements PipeTransform {
  termLength = new Map<number, string>();

  constructor() {
    this.termLength.set(1, "1-Month")
      .set(3, "3-Month")
      .set(6, "6-Month");
  }

  transformscfilter(value: number | undefined, leaseType: string | undefined): string | undefined {
    if (value === undefined) {
      return undefined;
    }
    if (leaseType === 'BilledMonthly') {
      this.termLength.set(14, "Billed Monthly");
    } else {
      this.termLength.set(12, "12-Month");
    }
    if (!this.termLength.get(value)) {
      return `${value}`;
    }
    return this.termLength.get(value);
  }

  transform(value?: number, leaseType?: string): string | undefined {
    if (value === undefined) {
      return undefined;
    }
    if (leaseType === 'BilledMonthly') {
      this.termLength.set(12, "Billed Monthly");
    } else {
      this.termLength.set(12, "12-Month");
    }
    if (!value || !this.termLength.get(value)) {
      return `${value}`;
    }
    return this.termLength.get(value);
  }

}

@Pipe({
  name: 'leaseType'
})
export class LeaseTypePipe implements PipeTransform {
  leaseType = new Map<string, string>();

  constructor() {
    this.leaseType.set("Prepay", "Prepay").set("BilledMonthly", "Billed Monthly").set("FreeCarrierCode", "Free Carrier Code");
  }

  transform(value: string): string | undefined {
    if (!value || !this.leaseType.get(value)) {
      return value;
    }
    return this.leaseType.get(value);
  }

}

@Pipe({
  name: 'leaseStatus'
})
export class LeaseStatusPipe implements PipeTransform {
  leaseStatus = new Map<string, string>();
  leaseStatusReason = new Map<string, string>();

  constructor() {
    this.leaseStatus.set("Approved", "Approved").set("PendingNew", "Pending New").set("PendingRenew", "Pending Renew").set("Cancelled", "Cancelled");
    this.leaseStatusReason.set("NoPay", "Did not Pay").set("NoRenew", "Did not Renew").set("MbOptOut", "MB Opt Out").set("CancelRequested", "Cancel Requested").set("Reactivated", "Reactivated").set("Rollback", "Rollback");
  }

  transform(value?: string, statusReason?: string): string | undefined {
    if (!value || !this.leaseStatus.get(value)) {
      return value;
    }
    if (statusReason) {
      if (this.leaseStatusReason.get(statusReason)) {
        return `${this.leaseStatus.get(value)} (${this.leaseStatusReason.get(statusReason)})`;
      } else {
        return `${this.leaseStatus.get(value)} (${statusReason})`;
      }
    } else {
      return this.leaseStatus.get(value);
    }
  }

}

@Pipe({
  name: 'orderStatus'
})
export class OrderStatusPipe implements PipeTransform {

  transform(value?: OrderStatus): string | undefined {
    switch (value) {
      case 'PaymentDue': return 'Payment Due'; break;
      case 'PaymentOverdue': return 'Payment Overdue'; break;
      case 'BilledMonthly': return 'Billed Monthly'; break;
      case 'AutoPay': return 'Auto Pay'; break;  // added for monthly billing invoice.
      default:
        // either exact same english value or undefined.
        return value;
    }
  }
}



@Pipe({
  name: 'orderType'
})
export class OrderTypePipe implements PipeTransform {

  transform(value?: OrderType): string | undefined {
    switch (value) {
      case OrderType.BilledMonthly: return 'Billed Monthly'; break;
      case OrderType.Prepay: return 'Prepay'; break;
      case OrderType.FreeCarrierCode: return 'Free Carrier Code'; break;
      default:
        return value;
    }
  }
}


@Pipe({
  name: 'statusReason'
})
export class StatusReasonPipe implements PipeTransform {
  statusReason = new Map<string, string>();

  constructor() {
    this.statusReason.set("NoPay", "Did not Pay").set("NoRenew", "Did not Renew").set("MbOptOut", "MB Opt Out").set("CancelRequested", "Cancel Requested").set("Reactivated", "Reactivated");

  }

  transform(value?: StatusReason): string | undefined {
    if (!value || !this.statusReason.get(value)) {
      return value;
    } else {
      return this.statusReason.get(value);
    }
  }
}


@Pipe({
  name: 'autoRenew'
})
export class AutoRenewPipe implements PipeTransform {

  transform(value?: boolean): string {
    return value ? 'Enrolled' : 'Not Enrolled';
  }


}

@Pipe({
  name: 'transferType'
})
export class TransferTypePipe implements PipeTransform {
  transferType = new Map<string, string>();

  constructor() {
    this.transferType.set("MonthlyBilling", "Monthly Billing").set("Autorenew", "Prepay Auto-Renew");
  }

  transform(value: string): string | undefined {
    if (!value || !this.transferType.get(value)) {
      return value;
    } else {
      return this.transferType.get(value);
    }
  }

}

@Pipe({
  name: 'pmAccountType'
})
export class PaymentMethodAccountTypePipe implements PipeTransform {
  pmAccountType = new Map<string, string>();

  constructor() {
    this.pmAccountType.set("Checking", "Checking").set("CorporateChecking", "Corporate Checking").set("Saving", "Savings");
  }

  transform(value: string): string | undefined {
    if (!value || !this.pmAccountType.get(value)) {
      return value;
    } else {
      return this.pmAccountType.get(value);
    }
  }

}


@Pipe({
  name: 'offerType'
})
export class OfferTypePipe implements PipeTransform {

  transform(v: number | undefined): string | undefined {

    if (v === undefined) {
      return '';
    }

    switch (v) {
      case 74: return 'Standard';
      case 75: return 'Government';
      case 76: return 'Charity';
      case 77: return '3rd Party Government';
      case 78: return 'Legacy Promo';
      case 79: return 'iconectiv Promo';
      case 80: return 'Promo+Charity';
      case 81: return 'Promo+Government';
      case 0: return 'N/A';
      default: return `${v}`;
    }
  }

}


@Pipe({
  name: 'yesNo'
})
export class YesNoPipe implements PipeTransform {

  transform(value?: boolean, isNA?: boolean): string {
    if (isNA === true) {
      return 'N/A';
    }

    if (value === true) {
      return 'Yes';
    }
    else if (value === false) {
      return 'No';
    }
    else {
      return '';
    }
  }
}



@Pipe({
  name: 'trueFalse'
})
export class TrueFalsePipe implements PipeTransform {

  transform(value: boolean, isNA?: boolean): string {
    if (isNA === true) {
      return 'N/A';
    }

    if (value === true) {
      return 'true';
    }
    else if (value === false) {
      return 'false';
    }
    else {
      return '';
    }
  }
}
@Pipe({
  name: 'discountSummary'
})
export class DiscountSummaryPipe implements PipeTransform {

  transform(value?: DiscountSummary[]): string {
    if (!value || value.length === 0) {
      return '';
    }
    else {
      return value.map(disc => disc.displayName).join(', ');
    }
  }

}

@Pipe({
  name: 'leaseStatusReason'
})
export class LeaseStatusReasonPipe implements PipeTransform {
  leaseStatusReason = new Map<string,string>();

  constructor() {
    this.leaseStatusReason.set("NoPay", "Did not Pay").set("NoRenew", "Did not Renew").set("MbOptOut", "MB Opt Out").set("CancelRequested", "Cancel Requested").set("Reactivated", "Reactivated").set("Rollback", "Rollback");
  }

  transform(value?: string): string | undefined {
    if (!value) {
      return value;
    }
    return this.leaseStatusReason.get(value);
  }

}

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any, args?: any): any {
    if (!value) return null;
    if (!args) return value;
    args = args.toLowerCase();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return value.filter((item: any) => {
      return JSON.stringify(item).toLowerCase().includes(args);
    });
  }

}


